<template lang="html">
  <div class="modal-overlay" @click="clickaway">
    <div class="modal">
      <i class="fa fa-times close row center middle" @click="$emit('close')"></i>
      <carousel
        :navigation-enabled="true"
        navigation-next-label=">"
        navigation-prev-label="<"
        :per-page="1"
        pagination-active-color="#EC3D33"
      >
        <slide v-for="(item, index) in items" :key="item">
          <div
            style="margin: 0 auto;width: 80vw; height: 80vh;background-size: contain;background-repeat: no-repeat; background-position: center;"
            :style="{ backgroundImage: 'url(' + item + ')'}"
          ></div>
        </slide>
      </carousel>
    </div>
  </div>
</template>

<script>
import { Carousel, Slide } from "vue-carousel";
export default {
  props: {
    items: {
      type: Array
    }
  },
  methods: {
    clickaway(event) {
      if (event.target === this.$el) this.$emit("close");
    }
  },
  components: {
    Carousel,
    Slide
  },
  mounted() {
    document.body.style.overflow = "hidden";
  },
  beforeDestroy() {
    document.body.style.overflow = "";
  }
};
</script>

<style scoped lang="scss">
@import "../styles/base/_colors";

.close {
  position: fixed;
  top: 20px;
  right: 20px;
  padding: 1rem;
  background: $primary;
  color: white;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  cursor: pointer;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(darken($primary, 25%), 0.75);
  z-index: 10;
  padding: 3em;
}
</style>
